import { ClerkProvider } from "@clerk/clerk-react";
import type { ReactNode } from "react";

const sClerkPublishableKey =
  import.meta.env.VITE_APP_CLERK_PUBLISHABLE_KEY || "";

interface iAuthProviderProps {
  children: ReactNode;
}

/**
 * Wraps children with ClerkProvider. Always renders children regardless of
 * auth state — the canvas must never be blocked by authentication loading.
 * If the publishable key is missing, renders children without Clerk
 * (anonymous-only mode).
 */
export const AuthProvider = ({ children }: iAuthProviderProps) => {
  if (!sClerkPublishableKey) {
    return <>{children}</>;
  }

  return (
    <ClerkProvider publishableKey={sClerkPublishableKey}>
      {children}
    </ClerkProvider>
  );
};
